// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => ("./" + {"121":"vendor","314":"style"}[chunkId] + ".css");